import { ProductScanner } from '../scanner-product.js';
import { getNotasLocal, saveProdutoScanned, getProdutosScanned, deleteProdutoScanned } from '../db.js';
import { authManager } from '../auth-manager.js';

let activeProductScanner = null;

export function renderScannerProductView(container, param, syncManager) {
  container.innerHTML = `
    <div class="detail-header" style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1.25rem;">
      <button class="detail-back" id="btn-back-scanner-product" style="background: #ECEAE3; border: none; color: #111827; cursor: pointer; padding: 0.45rem; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
        <span class="material-symbols-outlined" style="font-size: 20px;">arrow_back</span>
      </button>
      <div>
        <h2 style="margin: 0; font-size: clamp(1.25rem, 4.5vw, 1.6rem); font-weight: 800; color: #111827; line-height: 1.2;">Scanner de Produtos</h2>
        <p class="text-muted" style="margin: 0.15rem 0 0 0; font-size: 0.82rem;">Aponte para o código de barras ou envie foto da etiqueta</p>
      </div>
    </div>

    <!-- Scanner Viewport with Overlay Controls -->
    <div class="scanner-viewport-wrapper" style="border-radius: 1.25rem; overflow: hidden; margin-bottom: 1.25rem; border: 1px solid var(--color-border); box-shadow: var(--shadow-card);">
      <div id="product-qr-reader" class="scanner-video-container"></div>

      <!-- Quick Camera Controls (Zoom & Torch) -->
      <div class="camera-controls-toolbar" id="camera-controls" style="position: absolute; bottom: 14px; left: 0; right: 0; display: flex; justify-content: center; align-items: center; gap: 0.6rem; z-index: 10; pointer-events: auto;">
        <button class="zoom-btn" data-zoom="1" style="background: rgba(15,23,42,0.75); border: 1px solid rgba(255,255,255,0.25); color: white; border-radius: 9999px; width: 42px; height: 42px; font-size: 0.82rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(10px); transition: all 150ms ease;">1x</button>
        <button class="zoom-btn active" data-zoom="1.8" style="background: #10B981; border: 1px solid #10B981; color: #FFFFFF; border-radius: 9999px; width: 42px; height: 42px; font-size: 0.82rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(10px); transition: all 150ms ease;">1.8x</button>
        <button class="zoom-btn" data-zoom="2.5" style="background: rgba(15,23,42,0.75); border: 1px solid rgba(255,255,255,0.25); color: white; border-radius: 9999px; width: 42px; height: 42px; font-size: 0.82rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(10px); transition: all 150ms ease;">2.5x</button>
        <button class="torch-btn" id="btn-torch" style="background: rgba(15,23,42,0.75); border: 1px solid rgba(255,255,255,0.25); color: white; border-radius: 9999px; width: 42px; height: 42px; cursor: pointer; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(10px); transition: all 150ms ease;">
          <span class="material-symbols-outlined" style="font-size: 20px;">flashlight_on</span>
        </button>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="chart-card mb-lg text-center" style="width: 100%; padding: 1.25rem; box-sizing: border-box; margin-bottom: 1.25rem;">
      <div style="display: flex; gap: 0.5rem; flex-wrap: wrap; margin-bottom: 0.85rem;">
        <button class="btn btn-primary" id="btn-upload-product-file" style="flex: 1; min-width: 140px; display: inline-flex; align-items: center; justify-content: center; gap: 0.375rem; font-weight: 700; padding: 0.75rem 1rem; border-radius: var(--radius-pill);">
          <span class="material-symbols-outlined" style="font-size: 18px;">photo_camera</span>
          Enviar Foto da Etiqueta
        </button>
      </div>
      <p class="text-muted" style="font-size: 0.78rem; line-height: 1.45; margin: 0;">
        💡 <strong>Dica:</strong> Aponte a câmera para o código de barras ou envie uma foto da prateleira.
      </p>
      <input type="file" id="product-file-input" accept="image/*" capture="environment" style="display: none;" />
    </div>

    <!-- Scanned Products History List in DB -->
    <div class="chart-card" style="width: 100%; padding: 1.25rem; box-sizing: border-box; margin-bottom: 2rem;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <span class="material-symbols-outlined" style="font-size: 22px; color: #10B981;">inventory_2</span>
          <h3 style="margin: 0; font-size: 1.05rem; font-weight: 800; color: #111827;">
            Produtos Escaneados
          </h3>
        </div>
        <span id="badge-scanned-count" style="background: #ECFDF5; border: 1px solid #A7F3D0; color: #047857; font-size: 0.75rem; font-weight: 700; padding: 0.2rem 0.6rem; border-radius: var(--radius-pill);">
          0 produtos
        </span>
      </div>

      <div id="scanned-products-list" style="display: flex; flex-direction: column; gap: 0.75rem;">
        <!-- Populated dynamically -->
      </div>
    </div>

    <!-- Product Scan Result Modal (Light & Modern) -->
    <div id="product-result-modal" class="modal-overlay hidden" style="position: fixed; inset: 0; background: rgba(15, 23, 42, 0.65); backdrop-filter: blur(8px); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 1rem; box-sizing: border-box;">
      <div class="product-modal-card" style="background: #FFFFFF; border: 1px solid var(--color-border); border-radius: 1.25rem; padding: 1.5rem; width: 100%; max-width: 480px; box-shadow: 0 20px 45px rgba(0,0,0,0.15); box-sizing: border-box; max-height: 90vh; overflow-y: auto;">
        
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 1.1rem;">
          <div>
            <div style="display: inline-flex; align-items: center; gap: 0.35rem; background: #ECFDF5; border: 1px solid #A7F3D0; color: #047857; padding: 0.2rem 0.6rem; border-radius: var(--radius-pill); font-size: 0.72rem; font-weight: 700; margin-bottom: 0.35rem;">
              <span class="material-symbols-outlined" style="font-size: 14px;">check_circle</span>
              <span id="product-modal-badge-status">Etiqueta / Produto Identificado</span>
            </div>
            <h3 id="product-modal-title" style="margin: 0; font-size: 1.15rem; font-weight: 800; color: #111827; line-height: 1.3;">
              Produto na Gôndola
            </h3>
          </div>
          <button id="btn-close-product-modal" type="button" style="background: #F1F5F9; border: none; color: #64748B; border-radius: 50%; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; cursor: pointer;">
            <span class="material-symbols-outlined" style="font-size: 18px;">close</span>
          </button>
        </div>

        <!-- Interactive Form Fields -->
        <form id="form-product-scanned" style="display: flex; flex-direction: column; gap: 0.85rem; margin-bottom: 1.1rem;">
          <!-- Field 1: Barcode / EAN -->
          <div>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.3rem;">
              <label for="input-prod-ean" style="font-size: 0.75rem; color: #64748B; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em;">
                Código de Barras (EAN)
              </label>
              <span id="product-modal-format" style="font-size: 0.7rem; background: #F1F5F9; padding: 0.15rem 0.45rem; border-radius: var(--radius-pill); font-family: var(--font-mono); color: #475569; font-weight: 600;">
                EAN_13
              </span>
            </div>
            <div style="position: relative; display: flex; align-items: center;">
              <input type="text" id="input-prod-ean" placeholder="Ex: 7891000100103" style="width: 100%; font-family: var(--font-mono); font-size: 1rem; font-weight: 700; letter-spacing: 0.04em; background: #FFFFFF; border: 1px solid var(--color-border); color: #111827; border-radius: 0.65rem; padding: 0.65rem 0.85rem; box-sizing: border-box; outline: none;" />
            </div>
          </div>

          <!-- Field 2: Description -->
          <div>
            <label for="input-prod-desc" style="display: block; font-size: 0.75rem; color: #64748B; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.3rem;">
              Nome / Descrição do Produto
            </label>
            <input type="text" id="input-prod-desc" list="prod-desc-datalist" placeholder="Ex: Sabão Líquido Omo 3L" style="width: 100%; font-size: 0.9rem; font-weight: 600; background: #FFFFFF; border: 1px solid var(--color-border); color: #111827; border-radius: 0.65rem; padding: 0.65rem 0.85rem; box-sizing: border-box; outline: none;" />
            <datalist id="prod-desc-datalist"></datalist>
          </div>

          <!-- Field 3: Price -->
          <div style="background: #F8FAFC; border: 1px solid var(--color-border); border-radius: 0.85rem; padding: 0.85rem;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.3rem;">
              <label for="input-prod-price" style="font-size: 0.78rem; color: #111827; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em;">
                Preço na Gôndola (R$)
              </label>
              <span class="text-muted" style="font-size: 0.7rem;">Digite o valor</span>
            </div>
            <div style="position: relative; display: flex; align-items: center;">
              <span style="position: absolute; left: 0.85rem; font-size: 1.25rem; font-weight: 800; color: #10B981;">R$</span>
              <input type="text" id="input-prod-price" inputmode="decimal" placeholder="0,00" style="width: 100%; font-size: 1.4rem; font-weight: 900; color: #10B981; background: #FFFFFF; border: 1px solid var(--color-border); border-radius: 0.65rem; padding: 0.55rem 0.85rem 0.55rem 2.6rem; box-sizing: border-box; outline: none;" />
            </div>
          </div>
        </form>

        <!-- Reactive History Price Match Card -->
        <div id="product-history-box" style="background: #F8FAFC; border: 1px solid var(--color-border); border-radius: 0.85rem; padding: 1rem; margin-bottom: 1.25rem;">
          <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.5rem;">
            <div style="display: flex; align-items: center; gap: 0.4rem; font-size: 0.82rem; font-weight: 800; color: #111827;">
              <span class="material-symbols-outlined" style="font-size: 18px; color: #2563EB;">history</span>
              Histórico no NFC-e Tracker
            </div>
            <span id="product-history-badge-count" style="font-size: 0.72rem; color: #64748B; font-weight: 600;"></span>
          </div>
          <div id="product-history-content">
            <p class="text-muted" style="font-size: 0.8rem; margin: 0;">Consultando histórico local de compras...</p>
          </div>
        </div>

        <!-- Modal Actions -->
        <div style="display: flex; flex-direction: column; gap: 0.5rem;">
          <button class="btn btn-primary" id="btn-save-and-scan-next" type="button" style="width: 100%; padding: 0.8rem; font-weight: 800; font-size: 0.9rem; display: flex; align-items: center; justify-content: center; gap: 0.4rem; border-radius: var(--radius-pill);">
            <span class="material-symbols-outlined" style="font-size: 18px;">qr_code_scanner</span>
            Salvar e Escanear Próximo
          </button>
          
          <div style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" id="btn-save-and-close" type="button" style="flex: 1; padding: 0.65rem; font-size: 0.82rem; font-weight: 700; display: flex; align-items: center; justify-content: center; gap: 0.35rem; border-radius: var(--radius-pill);">
              <span class="material-symbols-outlined" style="font-size: 16px;">save</span>
              Salvar e Fechar
            </button>
            <button class="btn btn-secondary" id="btn-modal-close" type="button" style="padding: 0.65rem 1rem; font-size: 0.82rem; border-radius: var(--radius-pill); font-weight: 700;">
              Cancelar
            </button>
          </div>
        </div>

      </div>
    </div>
  `;

  // UI Elements
  const btnUpload = container.querySelector('#btn-upload-product-file');
  const fileInput = container.querySelector('#product-file-input');
  const btnTorch = container.querySelector('#btn-torch');
  const zoomButtons = container.querySelectorAll('.zoom-btn');
  const scannedListContainer = container.querySelector('#scanned-products-list');
  const badgeScannedCount = container.querySelector('#badge-scanned-count');

  // Product Modal Elements
  const productModal = container.querySelector('#product-result-modal');
  const inputProdEan = container.querySelector('#input-prod-ean');
  const inputProdDesc = container.querySelector('#input-prod-desc');
  const inputProdPrice = container.querySelector('#input-prod-price');
  const productModalFormat = container.querySelector('#product-modal-format');
  const productModalTitle = container.querySelector('#product-modal-title');
  const productModalBadgeStatus = container.querySelector('#product-modal-badge-status');
  const productHistoryContent = container.querySelector('#product-history-content');
  const productHistoryBadgeCount = container.querySelector('#product-history-badge-count');
  const prodDescDatalist = container.querySelector('#prod-desc-datalist');
  const btnSaveAndScanNext = container.querySelector('#btn-save-and-scan-next');
  const btnSaveAndClose = container.querySelector('#btn-save-and-close');
  const btnModalClose = container.querySelector('#btn-modal-close');
  const btnCloseProductModal = container.querySelector('#btn-close-product-modal');

  let currentHistoryMatch = null;
  let isEditingSavedItem = false;
  let editingItemId = null;

  // Populate Datalist with distinct item descriptions from local NFC-e database
  const loadDescriptionSuggestions = async () => {
    const btnBack = container.querySelector('#btn-back-scanner-product');
    if (btnBack) {
      btnBack.addEventListener('click', () => {
        if (window.history.length > 1) {
          window.history.back();
        } else {
          window.location.hash = '#listas';
        }
      });
    }

    try {
      const notas = await getNotasLocal();
      if (!notas || notas.length === 0) return;
      const descSet = new Set();
      notas.forEach(n => {
        if (n.itens) {
          n.itens.forEach(it => {
            if (it.descricao && it.descricao.trim().length > 2) {
              descSet.add(it.descricao.trim());
            }
          });
        }
      });
      prodDescDatalist.innerHTML = Array.from(descSet).slice(0, 50).map(d => `<option value="${d}">`).join('');
    } catch (e) {
      console.warn('loadDescriptionSuggestions error:', e);
    }
  };
  loadDescriptionSuggestions();

  // Currency Mask Helper: 1599 -> 15,99
  const formatCurrencyInput = (val) => {
    const cleanDigits = (val || '').toString().replace(/\D/g, '');
    if (!cleanDigits) return '';
    const numeric = parseInt(cleanDigits, 10) / 100;
    return numeric.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const parseCurrencyInput = (val) => {
    if (!val) return null;
    const clean = val.replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '');
    const num = parseFloat(clean);
    return isNaN(num) ? null : num;
  };

  // Live Currency Formatting on Price Input
  inputProdPrice.addEventListener('input', (e) => {
    const rawVal = e.target.value;
    const formatted = formatCurrencyInput(rawVal);
    e.target.value = formatted;
    recalculateDynamicComparison();
  });

  // Re-check history if EAN or Description changes manually
  inputProdEan.addEventListener('change', async () => {
    await updateHistorySection();
  });

  inputProdDesc.addEventListener('input', () => {
    productModalTitle.textContent = inputProdDesc.value.trim() || 'Produto na Gôndola';
  });

  // Zoom control
  zoomButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const zoomVal = parseFloat(btn.getAttribute('data-zoom'));
      if (activeProductScanner) {
        activeProductScanner.setZoom(zoomVal);
        zoomButtons.forEach(b => {
          b.classList.remove('active');
          b.style.background = 'rgba(0,0,0,0.7)';
          b.style.borderColor = 'rgba(255,255,255,0.25)';
          b.style.color = 'white';
        });
        btn.classList.add('active');
        btn.style.background = 'var(--color-primary)';
        btn.style.borderColor = 'var(--color-primary)';
        btn.style.color = '#003824';
      }
    });
  });

  // Torch control
  btnTorch.addEventListener('click', async (e) => {
    e.stopPropagation();
    if (activeProductScanner) {
      const isOn = await activeProductScanner.toggleTorch();
      if (isOn) {
        btnTorch.style.background = '#F59E0B';
        btnTorch.style.borderColor = '#F59E0B';
        btnTorch.style.color = '#000';
      } else {
        btnTorch.style.background = 'rgba(0,0,0,0.7)';
        btnTorch.style.borderColor = 'rgba(255,255,255,0.25)';
        btnTorch.style.color = 'white';
      }
    }
  });

  btnUpload.addEventListener('click', () => {
    fileInput.click();
  });

  // Render list of scanned products below scanner
  const renderScannedProductsList = async () => {
    const products = await getProdutosScanned();
    badgeScannedCount.textContent = `${products.length} ${products.length === 1 ? 'produto' : 'produtos'}`;

    if (products.length === 0) {
      scannedListContainer.innerHTML = `
        <div style="text-align: center; padding: 2rem 1rem; color: var(--color-muted); font-size: 0.85rem;">
          <span class="material-symbols-outlined" style="font-size: 32px; opacity: 0.4; margin-bottom: 0.4rem;">barcode_reader</span>
          <div>Nenhum produto escaneado ainda nesta PoC.</div>
          <div style="font-size: 0.75rem; opacity: 0.7; margin-top: 0.25rem;">Aponte para uma embalagem ou envie a foto de uma etiqueta.</div>
        </div>
      `;
      return;
    }

    scannedListContainer.innerHTML = products.map(prod => {
      const formattedDate = prod.scannedAt ? new Date(prod.scannedAt).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '-';
      const shelfPrice = prod.precoGondola ? (prod.precoGondola.startsWith('R$') ? prod.precoGondola : `R$ ${prod.precoGondola}`) : 'Preço n/d';
      const historyPrice = prod.ultimoPrecoPago ? `R$ ${prod.ultimoPrecoPago.toFixed(2).replace('.', ',')}` : null;
      
      let badgeComparison = '';
      if (prod.diferencaPreco !== null && prod.diferencaPreco !== undefined) {
        if (prod.diferencaPreco > 0.05) {
          badgeComparison = `<span style="background: #FEF2F2; border: 1px solid #FECDD3; color: #DC2626; padding: 0.15rem 0.5rem; border-radius: var(--radius-pill); font-size: 0.72rem; font-weight: 700;">+R$ ${prod.diferencaPreco.toFixed(2).replace('.', ',')} (+${prod.diferencaPercent}%)</span>`;
        } else if (prod.diferencaPreco < -0.05) {
          badgeComparison = `<span style="background: #ECFDF5; border: 1px solid #A7F3D0; color: #047857; padding: 0.15rem 0.5rem; border-radius: var(--radius-pill); font-size: 0.72rem; font-weight: 700;">-R$ ${Math.abs(prod.diferencaPreco).toFixed(2).replace('.', ',')} (${prod.diferencaPercent}%)</span>`;
        } else {
          badgeComparison = `<span style="background: #EFF6FF; border: 1px solid #BFDBFE; color: #2563EB; padding: 0.15rem 0.5rem; border-radius: var(--radius-pill); font-size: 0.72rem; font-weight: 700;">Mesmo preço</span>`;
        }
      } else if (!historyPrice) {
        badgeComparison = `<span style="background: #F1F5F9; color: #64748B; padding: 0.15rem 0.5rem; border-radius: var(--radius-pill); font-size: 0.72rem; font-weight: 600;">Sem compra anterior</span>`;
      }

      return `
        <div class="product-item-card" data-id="${prod.id}" style="background: #F8FAFC; border: 1px solid var(--color-border); border-radius: 0.85rem; padding: 0.85rem 1rem; display: flex; flex-direction: column; gap: 0.45rem;">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex; align-items: center; gap: 0.45rem;">
              <span style="font-family: var(--font-mono); font-size: 0.75rem; font-weight: 700; color: #111827; background: #E2E8F0; padding: 0.15rem 0.45rem; border-radius: 0.35rem;">
                ${prod.barcode || prod.id}
              </span>
              <span style="font-size: 0.7rem; color: #64748B; background: #FFFFFF; border: 1px solid var(--color-border); padding: 0.1rem 0.35rem; border-radius: 0.25rem;">
                ${prod.format || 'EAN_13'}
              </span>
              ${prod.scanCount > 1 ? `<span style="font-size: 0.7rem; color: #D97706; font-weight: 700;">${prod.scanCount}x</span>` : ''}
            </div>
            <button class="btn-delete-product" data-id="${prod.id}" style="background: none; border: none; color: #94A3B8; cursor: pointer; padding: 0.2rem; display: flex; align-items: center;" title="Excluir da lista">
              <span class="material-symbols-outlined" style="font-size: 16px;">delete</span>
            </button>
          </div>

          <div style="font-size: 0.9rem; font-weight: 700; color: #111827; line-height: 1.3;">
            ${prod.descricao}
          </div>

          <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.4rem; padding-top: 0.4rem; border-top: 1px solid var(--color-border);">
            <div style="display: flex; align-items: baseline; gap: 0.5rem;">
              <span style="font-size: 1.1rem; font-weight: 900; color: #10B981;">${shelfPrice}</span>
              ${historyPrice ? `<span style="font-size: 0.75rem; color: #64748B;">Último: <strong style="color: #111827;">${historyPrice}</strong> (${prod.ultimoMercado || 'NFC-e'})</span>` : ''}
            </div>
            <div>
              ${badgeComparison}
            </div>
          </div>

          <div style="display: flex; justify-content: space-between; align-items: center; font-size: 0.72rem; color: #64748B; margin-top: 0.1rem;">
            <span>${formattedDate}</span>
            <button class="btn-open-modal-prod" data-id="${prod.id}" style="background: #FFFFFF; border: 1px solid var(--color-border); color: #111827; font-size: 0.75rem; font-weight: 700; cursor: pointer; padding: 0.2rem 0.55rem; border-radius: var(--radius-pill); display: flex; align-items: center; gap: 0.25rem;">
              <span class="material-symbols-outlined" style="font-size: 14px;">edit</span>
              Editar / Ver
            </button>
          </div>
        </div>
      `;
    }).join('');

    // Attach click events on items
    scannedListContainer.querySelectorAll('.btn-delete-product').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const id = btn.getAttribute('data-id');
        if (id) {
          await deleteProdutoScanned(id);
          syncManager.showToast('Produto removido da lista.', 'info');
        }
      });
    });

    scannedListContainer.querySelectorAll('.btn-open-modal-prod').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const id = btn.getAttribute('data-id');
        const prod = products.find(p => p.id === id);
        if (prod) {
          displayProductResult({
            barcode: prod.barcode,
            format: prod.format,
            price: prod.precoGondola ? prod.precoGondola.replace('R$', '').trim() : '',
            rawPrice: prod.rawPrecoGondola,
            description: prod.descricao,
            isFromSavedList: true,
            savedId: prod.id
          });
        }
      });
    });
  };

  // Product History Search Helper
  const searchProductHistory = async (barcode, description) => {
    try {
      const notas = await getNotasLocal();
      if (!notas || notas.length === 0) {
        return { matchFound: false, reason: 'Nenhuma nota cadastrada no histórico.' };
      }

      const cleanBarcode = (barcode || '').trim().replace(/\D/g, '');
      const descTokens = (description || '')
        .toUpperCase()
        .replace(/[^A-Z0-9\s]/g, '')
        .split(/\s+/)
        .filter(t => t.length > 2);

      const matches = [];

      for (const nota of notas) {
        if (!nota.itens || nota.itens.length === 0) continue;

        for (const item of nota.itens) {
          const itemCode = (item.codigo || '').trim().replace(/\D/g, '');
          const itemDesc = (item.descricao || '').toUpperCase();

          let isMatch = false;
          let score = 0;

          // 1. Exact barcode match
          if (cleanBarcode && itemCode && (itemCode === cleanBarcode || cleanBarcode.endsWith(itemCode) || itemCode.endsWith(cleanBarcode))) {
            isMatch = true;
            score = 100;
          }

          // 2. Fuzzy description tokens
          if (!isMatch && descTokens.length > 0) {
            let matchedTokens = 0;
            for (const tok of descTokens) {
              if (itemDesc.includes(tok)) matchedTokens++;
            }
            if (matchedTokens >= 2 || (descTokens.length === 1 && matchedTokens === 1)) {
              isMatch = true;
              score = (matchedTokens / descTokens.length) * 80;
            }
          }

          if (isMatch) {
            const unitPrice = item.valorUnitario || (item.valorTotal && item.quantidade ? item.valorTotal / item.quantidade : 0);
            matches.push({
              itemDesc: item.descricao,
              codigo: item.codigo,
              unitPrice,
              totalPrice: item.valorTotal,
              quantidade: item.quantidade,
              dataEmissao: nota.dataEmissao,
              razaoSocial: nota.emitente?.razaoSocial || 'Estabelecimento',
              score
            });
          }
        }
      }

      if (matches.length === 0) {
        return { matchFound: false, reason: 'Nenhuma compra correspondente encontrada no histórico de cupons.' };
      }

      matches.sort((a, b) => new Date(b.dataEmissao || 0) - new Date(a.dataEmissao || 0));
      const latest = matches[0];
      const minPrice = Math.min(...matches.map(m => m.unitPrice).filter(p => p > 0));

      return {
        matchFound: true,
        latest,
        minPrice,
        totalPurchases: matches.length
      };
    } catch (e) {
      console.warn('searchProductHistory error:', e);
      return { matchFound: false, reason: 'Erro ao consultar banco de dados local.' };
    }
  };

  // Recalculates Dynamic Price Comparison Card
  const recalculateDynamicComparison = () => {
    const currentPrice = parseCurrencyInput(inputProdPrice.value);
    
    if (!currentHistoryMatch || !currentHistoryMatch.matchFound || !currentHistoryMatch.latest) {
      productHistoryContent.innerHTML = `
        <div style="font-size: 0.8rem; color: var(--color-muted); line-height: 1.4;">
          ℹ️ Este produto ainda não consta no histórico de notas fiscais salvas no aplicativo.
        </div>
      `;
      productHistoryBadgeCount.textContent = '';
      return;
    }

    const latest = currentHistoryMatch.latest;
    const formattedDate = latest.dataEmissao ? new Date(latest.dataEmissao).toLocaleDateString('pt-BR') : '-';
    const lastPrice = latest.unitPrice ? `R$ ${latest.unitPrice.toFixed(2).replace('.', ',')}` : '-';

    productHistoryBadgeCount.textContent = `${currentHistoryMatch.totalPurchases} compra(s)`;

    let diffHtml = '';
    if (currentPrice && latest.unitPrice > 0) {
      const diff = currentPrice - latest.unitPrice;
      const diffPercent = ((diff / latest.unitPrice) * 100).toFixed(1);

      if (diff > 0.05) {
        diffHtml = `
          <div style="margin-top: 0.6rem; padding: 0.5rem 0.75rem; background: #FEF2F2; border: 1px solid #FECDD3; border-radius: 0.5rem; color: #DC2626; font-size: 0.8rem; font-weight: 700; display: flex; align-items: center; gap: 0.35rem;">
            <span class="material-symbols-outlined" style="font-size: 16px;">trending_up</span>
            +R$ ${diff.toFixed(2).replace('.', ',')} (+${diffPercent}%) mais caro que a última compra!
          </div>
        `;
      } else if (diff < -0.05) {
        diffHtml = `
          <div style="margin-top: 0.6rem; padding: 0.5rem 0.75rem; background: #ECFDF5; border: 1px solid #A7F3D0; border-radius: 0.5rem; color: #047857; font-size: 0.8rem; font-weight: 700; display: flex; align-items: center; gap: 0.35rem;">
            <span class="material-symbols-outlined" style="font-size: 16px;">trending_down</span>
            -R$ ${Math.abs(diff).toFixed(2).replace('.', ',')} (${diffPercent}%) mais barato! Boa oferta.
          </div>
        `;
      } else {
        diffHtml = `
          <div style="margin-top: 0.6rem; padding: 0.5rem 0.75rem; background: #EFF6FF; border: 1px solid #BFDBFE; border-radius: 0.5rem; color: #2563EB; font-size: 0.8rem; font-weight: 700; display: flex; align-items: center; gap: 0.35rem;">
            <span class="material-symbols-outlined" style="font-size: 16px;">equal</span>
            Mesmo preço da sua última compra.
          </div>
        `;
      }
    }

    productHistoryContent.innerHTML = `
      <div style="font-size: 0.82rem; line-height: 1.45;">
        <div style="display: flex; justify-content: space-between; margin-bottom: 0.25rem;">
          <span class="text-muted">Último Preço Pago:</span>
          <strong style="color: #111827; font-size: 0.95rem;">${lastPrice}</strong>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 0.25rem;">
          <span class="text-muted">Data da Compra:</span>
          <span style="color: #111827; font-weight: 600;">${formattedDate}</span>
        </div>
        <div style="display: flex; justify-content: space-between; margin-bottom: 0.25rem;">
          <span class="text-muted">Local:</span>
          <span style="color: #111827; font-weight: 600;">${latest.razaoSocial}</span>
        </div>
        ${diffHtml}
      </div>
    `;
  };

  // Queries history and updates section
  const updateHistorySection = async () => {
    const ean = inputProdEan.value.trim();
    const desc = inputProdDesc.value.trim();
    currentHistoryMatch = await searchProductHistory(ean, desc);

    // If description is empty and we found a match in history by EAN, autopopulate description!
    if (!desc && currentHistoryMatch.matchFound && currentHistoryMatch.latest?.itemDesc) {
      inputProdDesc.value = currentHistoryMatch.latest.itemDesc;
      productModalTitle.textContent = currentHistoryMatch.latest.itemDesc;
    }

    recalculateDynamicComparison();
  };

  // Open Interactive Product Modal
  const displayProductResult = async (result) => {
    if (activeProductScanner && activeProductScanner.isScanning) {
      activeProductScanner.stop().catch(() => {});
    }

    isEditingSavedItem = !!result.isFromSavedList;
    editingItemId = result.savedId || null;

    const barcode = (result.barcode || '').trim();
    const format = result.format || 'EAN_13';
    const priceStr = result.price ? formatCurrencyInput(result.price) : '';
    const descStr = (result.description || '').trim();

    inputProdEan.value = barcode;
    productModalFormat.textContent = format;
    inputProdDesc.value = descStr;
    inputProdPrice.value = priceStr;
    productModalTitle.textContent = descStr || (barcode ? `Produto (${barcode})` : 'Produto Identificado');
    productModalBadgeStatus.textContent = isEditingSavedItem ? 'Editar Produto Salvo' : 'Produto / Etiqueta Identificado';

    productHistoryContent.innerHTML = `
      <div style="display: flex; align-items: center; gap: 0.5rem; color: var(--color-muted); font-size: 0.8rem;">
        <span class="material-symbols-outlined" style="font-size: 16px; animation: spin 1s linear infinite;">sync</span>
        Consultando histórico de compras...
      </div>
    `;

    productModal.classList.remove('hidden');

    // Query history match
    await updateHistorySection();

    // Auto-focus logic: focus on first missing field for immediate fluid entry
    setTimeout(() => {
      if (!inputProdPrice.value) {
        inputProdPrice.focus();
      } else if (!inputProdDesc.value) {
        inputProdDesc.focus();
      } else if (!inputProdEan.value) {
        inputProdEan.focus();
      } else {
        btnSaveAndScanNext.focus();
      }
    }, 100);
  };

  // Save Scanned Product Handler
  const handleSaveProduct = async (shouldScanNext = false) => {
    const barcode = inputProdEan.value.trim();
    const desc = inputProdDesc.value.trim() || 'Produto sem descrição';
    const priceStr = inputProdPrice.value.trim();
    const rawPrice = parseCurrencyInput(priceStr);
    const format = productModalFormat.textContent || 'EAN_13';

    let diff = null;
    let diffPercent = null;
    if (rawPrice && currentHistoryMatch?.matchFound && currentHistoryMatch?.latest?.unitPrice) {
      diff = rawPrice - currentHistoryMatch.latest.unitPrice;
      diffPercent = ((diff / currentHistoryMatch.latest.unitPrice) * 100).toFixed(1);
    }

    const payload = {
      barcode,
      format,
      descricao: desc,
      precoGondola: priceStr ? `R$ ${priceStr}` : null,
      rawPrecoGondola: rawPrice,
      ultimoPrecoPago: currentHistoryMatch?.latest?.unitPrice || null,
      ultimoMercado: currentHistoryMatch?.latest?.razaoSocial || '',
      ultimaDataCompra: currentHistoryMatch?.latest?.dataEmissao || '',
      diferencaPreco: diff,
      diferencaPercent: diffPercent
    };

    if (editingItemId) {
      payload.id = editingItemId;
    }

    await saveProdutoScanned(payload);
    syncManager.showToast('Produto salvo no histórico com sucesso!', 'success');

    // Close modal
    productModal.classList.add('hidden');

    if (shouldScanNext) {
      // Re-enable camera seamlessly for rapid batch scanning
      if (activeProductScanner) {
        activeProductScanner.start().catch(() => {});
      }
    }
  };

  btnSaveAndScanNext.addEventListener('click', () => handleSaveProduct(true));
  btnSaveAndClose.addEventListener('click', () => handleSaveProduct(false));

  // Enter key inside form saves and scans next
  container.querySelector('#form-product-scanned').addEventListener('submit', (e) => {
    e.preventDefault();
    handleSaveProduct(true);
  });

  const closeProductModalHandler = () => {
    productModal.classList.add('hidden');
    if (activeProductScanner && !activeProductScanner.isScanning) {
      activeProductScanner.start().catch(() => {});
    }
  };

  btnModalClose.addEventListener('click', closeProductModalHandler);
  btnCloseProductModal.addEventListener('click', closeProductModalHandler);

  // File Upload Handler with graceful fallback and real-time progress
  fileInput.addEventListener('change', async (e) => {
    const file = e.target.files?.[0];
    if (file && activeProductScanner) {
      const originalBtnHtml = btnUpload.innerHTML;
      btnUpload.disabled = true;
      btnUpload.innerHTML = `
        <span class="material-symbols-outlined" style="font-size: 18px; animation: spin 1s linear infinite;">sync</span>
        <span id="upload-progress-text">Analisando imagem...</span>
      `;

      const progressTextEl = btnUpload.querySelector('#upload-progress-text');

      try {
        const onProgress = (msg) => {
          if (progressTextEl) progressTextEl.textContent = msg;
          syncManager.showToast(msg, 'info');
        };

        onProgress('Iniciando análise da foto...');
        const scanRes = await activeProductScanner.scanFile(file, onProgress);
        displayProductResult(scanRes);
      } catch (err) {
        console.warn('Product file scan error:', err);
        displayProductResult({
          barcode: '',
          format: 'EAN_13',
          price: '',
          description: '',
          data: ''
        });
      } finally {
        fileInput.value = '';
        btnUpload.disabled = false;
        btnUpload.innerHTML = originalBtnHtml;
      }
    }
  });


  // Listen to product list updates
  window.addEventListener('produtosscannedupdated', () => {
    renderScannedProductsList();
  });

  // Initial list render
  renderScannedProductsList();

  // Init Product Scanner
  if (activeProductScanner) {
    activeProductScanner.stop();
  }

  activeProductScanner = new ProductScanner('product-qr-reader', (decodedText, fullResult) => {
    displayProductResult(fullResult || { barcode: decodedText, format: 'EAN_13', data: decodedText });
  });

  activeProductScanner.start().catch((err) => {
    console.warn('Product Camera access error:', err);
    syncManager.showToast('Câmera indisponível. Utilize o envio de foto da etiqueta.', 'info');
  });
}

export function stopActiveProductScanner() {
  if (activeProductScanner) {
    activeProductScanner.stop();
    activeProductScanner = null;
  }
}
